// อ่าน query ของหน้า list กลับจาก url ตอนเข้าหน้า (refresh / กดย้อนกลับ)
// ไม่งั้น state perPage/filterQuery จะเริ่มใหม่ พอกดเปลี่ยนหน้าแล้วจำนวนแถวกับคำค้นหาจะหาย
// fixedKeys = key ที่ handleJoinQuery ต่อท้ายให้เองทุกครั้ง ต้องตัดออกไม่งั้นจะต่อซ้ำกลายเป็น array
// แยกด้วย & ตรง ๆ ไม่ใช้ URLSearchParams เพื่อเก็บรูปแบบค่าเดิมที่ InputFilter สร้างไว้
export const PARSE_LIST_QUERY = (search, defaultPerPage, fixedKeys = []) => {
  const omitKeys = ["limit", "page", ...fixedKeys];
  const parts = (search || "")
    .replace(/^\?/, "")
    .split("&")
    .filter((e) => e);
  const limitPart = parts.find((e) => e.split("=")[0] === "limit");
  const filterParts = parts.filter((e) => !omitKeys.includes(e.split("=")[0]));
  return {
    perPage: Number(limitPart && limitPart.split("=")[1]) || defaultPerPage,
    filterQuery: filterParts.length > 0 ? `?${filterParts.join("&")}` : "",
  };
};
